class LocalStorage {
  ref = window.localStorage;

  setItem(key, value) {
    this.ref.setItem(key, value);
  }

  getItem(key) {
    return this.ref.getItem(key);
  }
}

export const localStorage = new LocalStorage();

export const LocalStorageKeysMapping = {
  SEEN_MY_ARTICLES: 'SEEN_MY_ARTICLES',
  SEEN_DAILY_NEWS: 'SEEN_DAILY_NEWS',
};